import { TimetableList as TimetableListType } from 'types/timetable.types';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import TimetableListRows from './TimetableListRows';

function TimetableList({ data }: { data: TimetableListType[] }) {
  const { t } = useTranslation('timetable');

  return (
    <TableContainer
      component={Paper}
      variant="outlined"
      sx={{ flex: '1 1 auto', my: 3, position: 'relative' }}
    >
      <Table stickyHeader sx={{ tableLayout: 'fixed' }} aria-label="caption table">
        <caption>{t('table_caption')}</caption>

        <TableHead>
          <TableRow>
            <TableCell>{t('status')}</TableCell>
            <TableCell>{t('days')}</TableCell>
            <TableCell>{t('partitions')}</TableCell>
            <TableCell>{t('initial_hour')}</TableCell>
            <TableCell>{t('initial_hour_tolerance')}</TableCell>
            <TableCell>{t('final_hour')}</TableCell>
            <TableCell>{t('final_hour_tolerance')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TimetableListRows {...{ data }} />
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default TimetableList;
